import { TagModel } from "@/types/models/TagModel";
import { TherapeuticAreaModel } from "@/types/models/TherapeuticAreaModel";
import { useEffect, useState } from "react";

const TagButtonsRootField = ({ setData, dataKey = 'tags', tags, errors, storedData = [] }: {
    setData: (key: string, value: any) => void,
    dataKey?: string;
    tags: TagModel[]
    errors: { [key: string]: string }
    storedData?: string[]
}) => {
    const [activeAreas, setActiveAreas] = useState<string[]>([])

    useEffect(() => {
        if (storedData.length > 0) {
            setActiveAreas(storedData);
            setData(dataKey, storedData);

            return () => {}
        }
    }, []);

    const handleChangeArea = (id: string) => {
        const isActive = activeAreas.includes(id);

        const updatedAreas = isActive
            ? activeAreas.filter(areaId => areaId !== id)
            : [...activeAreas, id];

        setActiveAreas(updatedAreas);
        setData(dataKey, updatedAreas);
    };

    return (
        <>
            <div className="flex flex-wrap gap-4">
                {tags.map((area, i) => (
                    <button type="button" key={i} className={`border-1 transition-theme py-2 px-3 rounded-full text-arcticMist text-14 leading-18 ${activeAreas.includes(area.id) ? 'bg-gradientButton border-accordorange text-arcticMist' : 'text-midnightNavy border-royalPeriwinkle'}`} onClick={() => handleChangeArea(area.id)}>
                        {area.name}
                    </button>
                ))}
            </div>
        </>
    )
}

export default TagButtonsRootField;